import { inject, Injectable } from '@angular/core';
import { from, map, Observable } from 'rxjs';
import { COMMO_SHARED_SUPABASE_CLIENT } from '../commo-shared-data-access.config';

@Injectable({ providedIn: 'root' })
export class PushSubscriptionService {
  private readonly supabase = inject(COMMO_SHARED_SUPABASE_CLIENT);

  upsertSubscription(
    endpoint: string,
    p256dh: string,
    auth: string,
  ): Observable<void> {
    return from(
      this.supabase.rpc('upsert_push_subscription', {
        p_endpoint: endpoint,
        p_p256dh: p256dh,
        p_auth: auth,
      }),
    ).pipe(
      map(({ error }) => {
        if (error) throw new Error(error.message);
      }),
    );
  }

  deleteSubscription(endpoint: string): Observable<void> {
    return from(
      this.supabase.rpc('delete_push_subscription', {
        p_endpoint: endpoint,
      }),
    ).pipe(
      map(({ error }) => {
        if (error) throw new Error(error.message);
      }),
    );
  }

  notifyNoticePublished(noticeId: string): Observable<void> {
    // 事前確認は SW を通らない。本体の POST は ngsw が捕まえて Function に届かない。ngsw-bypass で SW の外へ出す。
    return from(
      this.supabase.functions.invoke(
        'notify-notice-published?ngsw-bypass=true',
        { body: { notice_id: noticeId } },
      ),
    ).pipe(
      map(({ error }) => {
        if (error) throw new Error(error.message);
      }),
    );
  }
}
